import marketLib from './market'

function getParticipantIds (event) {
  let result = {
    participantHomeId: '',
    participantAwayId: ''
  }

  let valid = event && event.markets && event.markets.length > 0

  if (valid) {
    for (var i = 0; i < event.markets.length; i++) {
      let selections = event.markets[i].selections ? event.markets[i].selections : null

      if (selections) {
        var homeSelection = selections.find((sel) => {
          return sel.hadvalue === 'H' && sel.idfoparticipant
        })
        var awaySelection = selections.find((sel) => {
          return sel.hadvalue === 'A' && sel.idfoparticipant
        })

        if (homeSelection && awaySelection) {
          break
        }
      }
    }

    result.participantHomeId = homeSelection ? homeSelection.idfoparticipant : ''
    result.participantAwayId = awaySelection ? awaySelection.idfoparticipant : ''
  }

  return result
}

function areSameSport (events) {
  var result

  if (events && Array.isArray(events) && events.length > 0) {
    switch (events.length) {
      case 1:
        result = true
        break
      default:
        var gotIt = events.find((event) => {
          return events[0].idfosporttype !== event.idfosporttype
        })

        result = !gotIt
    }
  }

  return result
}

function areSameBy (events, properties) {
  var result

  if (events && Array.isArray(events) && events.length > 0) {
    var gotIt = events.find((event) => {
      for (var i = 0; i < properties.length; i++) {
        let prop = properties[i]

        if (events[0][prop] !== event[prop]) {
          return true
        }
      }

      return false
    })

    result = !gotIt
  }

  return result
}

function isLive (event) {
  return event.isliveevent && event.idfobolifestate === 'O'
}
function isResulted (event) {
  return event.idfobolifestate !== 'O'
}
function hasBig3Markets (event) {
  var result = false

  if (marketsValid(event)) {
    result = event.markets.find(market => marketLib.isBig3Market(market))
  }

  return result
}

function isOutright (event) {
  var result = false

  if (marketsValid(event)) {
    result = event.idfobolifestate === 'O' && marketLib.isOutright(event.markets[0])
  }

  return result
}

function hasOutrightEvents (events) {
  var result = false

  if (events && events.length && events.length > 0) {
    result = events.find(ev => isOutright(ev))
  }

  return result
}

function getOutrightEvents (events) {
  var result = []

  if (events && events.length && events.length > 0 && hasOutrightEvents(events)) {
    result = events.filter(ev => isOutright(ev))
  }

  return result
}

function hasMoneyline (event) {
  var result = false

  if (marketsValid(event)) {
    result = event.markets.find(market => marketLib.isMoneyline(market))
  }

  return result
}

function getMoneylineMarkets (event) {
  var result = false

  if (marketsValid(event) && hasMoneyline(event)) {
    result = event.markets.filter(market => marketLib.isMoneyline(market))
  }

  return result
}

function teamNameIdentifier (evt, side = 'home') {
  var result = ''

  if (evt && evt.idfosporttype && ((evt.participantnameaway && evt.participantnamehome) || evt.participantname)) {
    var participantName = ''

    switch (side) {
      case 'home':
        participantName = evt.participantnamehome.replace('.', '')
        break
      case 'away':
        participantName = evt.participantnameaway.replace('.', '')
        break
    }

    result = [
      participantName
    ]

    result = result
              .join('-')
              .replace(/ /g, '-')
              .toLowerCase()
  }

  return result
}

function marketsValid (event) {
  return event && event.markets && event.markets.length > 0
}

export default {
  areSameSport,
  areSameBy,
  isResulted,
  isLive,
  hasMoneyline,
  getMoneylineMarkets,
  hasBig3Markets,
  isOutright,
  hasOutrightEvents,
  getOutrightEvents,
  teamNameIdentifier,
  getParticipantIds
}



// WEBPACK FOOTER //
// ./src/library/betting/event.js